import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

import ReactTable from "components/lib/Global/ReactTable";
// import SubRowAsync from "./SubRowAsync";
import {
  getCompanyDashboardAsync,
  getManageCompanyTransactions,
} from "state/slices/companyDashboard";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import TableActionMenuWrapper from "components/lib/Shared/TableActionMenuWrapper";
import { Menu } from "@headlessui/react";
import {
  EyeIcon,
  PencilAltIcon,
  PencilIcon,
  RefreshIcon,
  TrashIcon,
  UploadIcon,
} from "@heroicons/react/outline";
import { getMaintainYourCompanyReviewStatus } from "config/documentData";
import { Constants } from "config/constants";
import { getActionsForStatus } from "utils/getActionButtons";
import { setCookie } from "utils/cookie";
import { resetActiveDashboardSlice } from "state/slices/activeDashboard";
// import OfficialSubRow from "../MaintainYourCompany/CommonResources/ReviewTableFinal/OfficialSubRow";
// import ApplicationCorrections from "../MaintainYourCompany/ReviewerTabs/ApplicationCorrections";
// import DocumentSignature from "components/CompanyDashboard/MaintainYourCompany/CommonResources/DocumentSignature";
import {
  deleteCompanyOfficialAsync,
  updateCompanyOfficialAsync,
} from "state/slices/tables/companyOfficialsSlice";
import {
  deleteInitiatedTransactionChangeAsync,
  getAllInitiateTransactionChangeAsync,
  getTransactionChangeByBatchNumberAsync,
  recallInitiatedTransactionChangeAsync,
  resetTransactionChange,
} from "state/slices/initiateTransactionChange";
import { useToast } from "hooks/useToast";
import Dialog from "components/lib/Shared/Dialog";
import Button from "components/lib/Shared/Button";
import { openModal } from "state/slices/modals";
import RecentChangesTable from "../MaintainYourCompany/Changes/SharedComponents/RecentChangesTable";
// import RecentChangesSubRow from "../MaintainYourCompany/CommonResources/RecentChangesTable/subRow";
import { Roles_Permissions_Constants } from "config/roles-permissions";
import { getEmployeeAsync } from "state/slices/employee";
import { format } from "date-fns";
import TransactionChange from "./TransactionChange";
import BreadCrumb from "components/lib/Global/BreadCrumb";
import TransactionEdit from "../TransactionEditReviewSignature/TransactionEdit";
import { getCompany, handleRecallApplication } from "state/slices/company";
import CompanyDashboardContext from "context/CompanyDashboardContext";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getTransactionUnderReviewAsync } from "state/slices/transaction";
import { getEsignatureEmailLink } from "utils/esignature";
import EmptyTableState from "components/lib/Shared/EmptyTableState";
import { editBeneficialOwnerAsync } from "state/slices/tables/beneficialOwnersTableSlice";
import { ro } from "date-fns/locale";
import { deleteCompany } from "state/slices/companies";
import TableActionMenu from "components/lib/Shared/TableActionMenu";
import CompanySubRow from "./CompanySubRow";

const TransactionsList = (props) => {
  const history = useHistory();
  const {
    setCompanyDashboardTab,
    setSelectedChangesTab,
    setSelectedManageModuleTab,
    setSelectedOfficial,
    setShowChangesAndApprovals,
    goToTransactionList,
  } = useContext(CompanyDashboardContext);

  const { callFrom, rowId } = props;
  const isViewMode = false;
  const dispatch = useDispatch();
  const params = useParams();
  const [actionType, setActionType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [initialRows, setInitialRows] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [showOfficialFormModal, setShowOfficialFormModal] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showRecallModal, setShowRecallModal] = useState(false);
  const [showCorrectionModal, setShowCorrectionModal] = useState(false);
  const [workflowCompleted, setWorkflowCompleted] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [legalDepartmentEmployees, setLegalDepartmentEmployees] = useState([]);
  const [nonLegalDepartmentEmployees, setNonLegalDepartmentEmployees] =
    useState([]);
  const showBreadCrumbs = useState(true);
  const [batchNo, setBatchNo] = useState();
  const [updateTable, setUpdateTable] = useState(false);
  const currentUser = useSelector((state) => state.userSlice);
  const { dashboardPermissions, dashboardRoles, designation } = useSelector(
    (state) => state.companyDashboardSlice
  );
  const { companyId } = useParams();
  const { initiatedTransactions, getInitiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );

  let pages = [
    { name: "Home", href: "#", current: true },
    { name: "Transaction", href: "#", current: true },
  ];
  if (actionType) {
    pages.push({ name: "Change", href: "#", current: true });
  }
  useEffect(() => {
    dispatch(getCompany({ id: params.companyId }));
  }, []);
  useEffect(() => {
    if (params.companyId) {
      dispatch(getEmployeeAsync({ companyId: params.companyId }));
    }
  }, [dispatch, params.companyId]);
  const { getEmployee } = useSelector((state) => state.employeeSlice);

  const isRegistrar = dashboardRoles.some(
    (role) =>
      role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
  );

  const isUploader = dashboardRoles.some(
    (role) => role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.UPLOADER
  );

  const renderRowSubComponent = React.useCallback(
    ({ row, rowProps, visibleColumns }) => {
      if (row?.original?.registrationName) {
        return <CompanySubRow row={row} visibleColumns={visibleColumns} />;
      }
      if (actionType === "edit") {
        return (
          <RecentChangesTable
            showOfficialFormModalValue={true}
            companyId={params.companyId}
            RecentChangesTable={true}
            data={[row.original]}
            statusToBeChanged={
              Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_APPROVAL
            }
            onComplete={(message) => {
              setWorkflowCompleted(true);
              setAlertMessage(message);
            }}
          />
        );
      }
    },
    [actionType]
  );
  useEffect(() => {
    if (getEmployee?.items) {
      setLegalDepartmentEmployees(
        getEmployee.items.filter(
          (employee) => employee.isLegalDepartment === true
        )
      );
      setNonLegalDepartmentEmployees(
        getEmployee.items.filter(
          (employee) => employee.isLegalDepartment === false
        )
      );
    }
  }, [getEmployee]);

  const getFilteredTransactions = (transactions) => {
    return (
      transactions.filter((transaction) => {
        if (callFrom === "draft") {
          if (isUploader || isRegistrar) {
            return (
              transaction.changeType &&
              Object.values(Constants.MAINTAIN_COMPANY_DRAFT_STATUS).includes(
                transaction.status
              )
            );
          }
          return (
            transaction.changeType &&
            Object.values(Constants.MAINTAIN_COMPANY_DRAFT_STATUS).includes(
              transaction.status
            ) &&
            transaction.createdBy === currentUser._id
          );
        } else if (callFrom === "signature") {
          const isUserESignatureRequired =
            transaction.changeType &&
            Object.values(Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS).includes(
              transaction.status
            ) &&
            transaction?.envelopes?.some((envelope) =>
              envelope?.signatures?.some(
                (signer) => signer?.signer_email_address === currentUser.email
              )
            );

          if (isUserESignatureRequired) {
            return true;
          }
          return (
            (isUploader || isRegistrar) &&
            transaction.changeType &&
            Object.values(Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS).includes(
              transaction.status
            )
          );
        } else if (callFrom === "review") {
          return (
            transaction.changeType &&
            Object.values(Constants.MAINTAIN_COMPANY_REVIEW_PROCESS).includes(
              transaction.status
            )
          );
        } else {
          return true;
        }
      }) || []
    );
  };

  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    setTableData(getFilteredTransactions(initiatedTransactions.items));
  }, [initiatedTransactions]);

  useEffect(async () => {
    await dispatch(
      getAllInitiateTransactionChangeAsync({
        companyId,
        params: {
          limit: 10,
          skip: (currentPage - 1) * 10,
          search: "",
          isCompanyDashboard: true,
        },
      })
    );
  }, [currentPage]);

  useEffect(async () => {
    if (updateTable === true) {
      await dispatch(
        getAllInitiateTransactionChangeAsync({
          companyId,
          params: {
            limit: 10,
            skip: (currentPage - 1) * 10,
            search: "",
            isCompanyDashboard: true,
          },
        })
      );
      setUpdateTable(false);
    }
  }, [updateTable]);

  useEffect(() => {
    setShowConfirmationDialog(false);
    setShowRecallModal(false);
  }, [alertMessage]);

  const handleEdit = (row) => {
    let batchNo = row.original?.batchNo ? row.original.batchNo : null;
    if (batchNo) {
      dispatch(getTransactionChangeByBatchNumberAsync({ batchNo }));
    }
  };

  const handleView = (row) => {
    row.toggleRowExpanded();
  };

  const handleReview = (row) => {
    const trxRef = row.original?.trxRef;
    const batchNo = row.original?.batchNo;
    const data = {
      trxRef,
      batchNo,
    };
    dispatch(
      getTransactionUnderReviewAsync({
        trxId: row.original._id,
        queryParams: {},
        data,
      })
    );
  };

  const columns = [
    {
      Header: "Batch No.",
      accessor: "BatchNo",
      Cell: ({ row }) => {
        if (row.original?.registrationName) {
          return row?.original?.registrationName;
        }
        if (row.original?.companyName1) {
          return row.original?.companyName1;
        }
        return row?.original?.batchNo || "-";
      },
    },
    {
      Header: "Application Type",
      accessor: "applicationType",

      Cell: ({ row }) => {
        let applicationType = "Incorporation";
        if (row.original?.applicationType) {
          applicationType = row.original?.applicationType;
        }
        if (row.original?.transferYourBusinessInitiator) {
          applicationType = "Transfer Your Business";
        }
        return applicationType;
      },
    },
    {
      Header: "Change Type",
      accessor: "changeType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          let word =
            str.split("-").join(" ").charAt(0).toUpperCase() +
            str.split("-").join(" ").slice(1).toLowerCase();
          return word;
        };

        return capitalize(original?.changeType) || original?.type || "-";
      },
    },
    {
      Header: "Transaction Type",
      accessor: "transactionType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          let transactionType =
            str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
          return transactionType;
        };
        if (original?.transferYourBusinessInitiator) {
          return "Transfer Your Business";
        }
        return capitalize(original?.transactionType) || "Automatic";
      },
    },
    {
      Header: "Tnx No.",
      accessor: "TnxNo",
      Cell: ({ row: { original } }) => {
        return original?.trxRef || original?.registrationNumber || "-";
      },
    },
    {
      Header: "Date",
      Cell: ({ row: { original } }) => {
        const date = original?.updatedAt || original?.updatedAt;
        return date ? format(new Date(date), "yyyy/MM/dd") : "N/A";
      },
    },
    {
      Header: "Status",
      Cell: ({ row }) => {
        if (row?.original?.applicationType) {
          return getMaintainYourCompanyReviewStatus(row.original?.status);
        } else {
          return row.original?.status || "-";
        }
      },
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        if (
          row.original?.registrationName &&
          !row.original?.transferYourBusinessInitiator
        ) {
          return (
            <TableActionMenu
              row={row}
              hideDeleteBtn={true}
              hideEditBtn={true}
              showViewBtn={!row.isExpanded}
              handleView={handleView}
              showCloseBtn={row.isExpanded}
              handleClose={handleView}
            />
          );
        }
        return (
          <ActionButtons
            actionType={actionType}
            setActionType={setActionType}
            row={row}
            setSelectedRow={setSelectedRow}
            setShowConfirmationDialog={setShowConfirmationDialog}
            selectedRow={selectedRow}
            setShowRecallModal={setShowRecallModal}
            setShowCorrectionModal={setShowCorrectionModal}
            setShowOfficialFormModal={setShowOfficialFormModal}
            dashboardPermissions={dashboardPermissions}
            dashboardRoles={dashboardRoles}
            designation={designation}
            nonLegalDepartmentEmployees={nonLegalDepartmentEmployees}
            legalDepartmentEmployees={legalDepartmentEmployees}
            setBatchNo={setBatchNo}
            handleEdit={handleEdit}
            companyId={companyId}
            handleReview={handleReview}
          />
        );
      },
    },
  ];

  // Render the spinner if the data is loading
  if (getInitiatedTransactions.status === "loading") {
    return (
      <div
        className="absolute inset-0 flex items-center justify-center bg-gray-200/50 z-10"
        id="loading-overlay"
      >
        <SpinnerIcon textColor="text-gray-400" />
      </div>
    );
  }
  const handleExitDashboard = () => {
    setCookie("role", Constants.COOKIE_ROLES.APPLICANT);
    dispatch(resetActiveDashboardSlice());
    history.push("/companies");
  };

  const handleBackToTransactionsList = () => {
    setActionType("");
    setBatchNo(null);
  };

  return (
    <>
      {!callFrom && (
        <div className="bg-white container mx-auto px-4">
          <div className="">
            {showBreadCrumbs && actionType !== "edit" && (
              <BreadCrumb
                pages={pages}
                handleExitDashboard={handleExitDashboard}
              />
            )}
          </div>
        </div>
      )}

      {!actionType || actionType === "delete" || actionType === "recall" ? (
        <div className="mt-6 w-full bg-white shadow overflow-x-auto">
          {tableData?.length > 0 ? (
            <ReactTable
              columns={columns}
              data={tableData || []}
              dataRowCellStyle="pl-4 leading-snug py-2"
              paginate={true}
              totalRows={
                callFrom ? tableData.length : initiatedTransactions.totalCount
              }
              renderRowSubComponent={renderRowSubComponent}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          ) : getInitiatedTransactions.status === "loading" ? (
            <div className="z-10 flex items-center justify-center mt-10">
              <SpinnerIcon className="text-gray-400" />
            </div>
          ) : (
            <EmptyTableState>No transactions</EmptyTableState>
          )}

          {showConfirmationDialog && (
            <ConfirmationModal
              setShowConfirmationDialog={setShowConfirmationDialog}
              selectedRow={selectedRow}
              setUpdateTable={setUpdateTable}
              currentPage={currentPage}
              companyId={companyId}
            />
          )}
          {showRecallModal && (
            <RecallModal
              setUpdateTable={setUpdateTable}
              setShowRecallModal={setShowRecallModal}
              selectedRow={selectedRow}
              onComplete={(message) => {
                setWorkflowCompleted(true);
                setAlertMessage(message);
              }}
            />
          )}
        </div>
      ) : (
        <div>
          {batchNo && selectedRow && (
            <TransactionChange
              actionType={actionType}
              batchNo={batchNo}
              setActionType={setActionType}
              setUpdateTable={setUpdateTable}
              goToTransactionList={goToTransactionList}
              row={selectedRow}
            />
          )}
          <div>
            <button onClick={handleBackToTransactionsList}>
              Back to transactions list
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const ActionButtons = ({
  setActionType,
  row,
  setSelectedRow,
  setShowConfirmationDialog,
  setShowRecallModal,
  setShowCorrectionModal,
  setShowOfficialFormModal,
  dashboardPermissions,
  dashboardRoles,
  designation,
  legalDepartmentEmployees,
  nonLegalDepartmentEmployees,
  setBatchNo,
  handleEdit,
  companyId,
  handleReview,
}) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.userSlice);
  const { company } = useSelector((state) => state.companyDashboardSlice);

  const { DIRECTOR, DIRECTOR_SHAREHOLDER } = Constants.APPLICANT_CAPACITIES;
  const actionButtons = getActionsForStatus(row.original.status);
  const isCorrectionActionNeeded = Object.values(
    Constants.MAINTAIN_COMPANY_CORRECTIONS_STATUSES
  ).includes(row.original.status);
  const { initiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );

  const isWithdrawalStrikeOffTransaction = initiatedTransactions.items.some(
    (transaction) =>
      transaction.status !== Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DRAFT &&
      transaction.status !==
      Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.PROCESSED &&
      transaction.changeType ===
      Constants.TRANSACTION_CHANGE_TYPES.NOTICE_OF_WITHDRAWAL_OF_STRIKE_OFF
  );
  const onlyShowViewForStrikeOffTransaction =
    isWithdrawalStrikeOffTransaction &&
    row?.original?.changeType === Constants.TRANSACTION_CHANGE_TYPES.STRIKE_OFF;

  const companyOnStrikeOff =
    (company?.status === Constants.ENTITY_STATUS.STRUCK_OFF ||
      company?.status === Constants.ENTITY_STATUS.STRIKE_OFF_ONGOING) &&
    row?.original?.changeType !==
    Constants.TRANSACTION_CHANGE_TYPES.STRIKE_OFF &&
    row?.original?.changeType !==
    Constants.TRANSACTION_CHANGE_TYPES.NOTICE_OF_WITHDRAWAL_OF_STRIKE_OFF &&
    row?.original?.changeType !==
    Constants.TRANSACTION_CHANGE_TYPES.ADMINISTRATIVE_RESTORATION;

  return (
    <div>
      <TableActionMenuWrapper>
        <Menu.Item>
          {({ active }) => (
            <>
              <Link
                to={
                  (row.original?.registrationName ||
                    row.original?.companyName1) &&
                    !row.original?.transferYourBusinessInitiator
                    ? `/companies/${row.original._id}/view`
                    : row.original?.transferYourBusinessInitiator
                      ? `/transferYourBusiness/${row.original._id}/view`
                      : `/companies/${companyId}/dashboard/transactions/${row.original._id}/view`
                }
              >
                <button
                  type="button"
                  onClick={() => null}
                  className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                    } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                >
                  <>
                    <EyeIcon className="w-5 h-5 mr-2" aria-hidden="true" />
                    View
                  </>
                </button>
              </Link>
            </>
          )}
        </Menu.Item>
        {
          <>
            {actionButtons.includes("review") &&
              dashboardRoles.some((role) => {
                if (
                  role.name ===
                  Roles_Permissions_Constants.DASHBOARD_ROLES.REVIEWER &&
                  designation === DIRECTOR
                ) {
                  return [
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_REVIEW,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .DIRECTOR_REVIEW_II,
                  ].includes(row.original.status);
                }

                if (
                  role.name ===
                  Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
                ) {
                  return [
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .REGISTRAR_REVIEW_II,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .REGISTRAR_CS_REVIEW,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .REGISTRAR_CS_REVIEW_II,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .REGISTRAR_DR_REVIEW,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .REGISTRAR_DR_REVIEW_II,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .REGISTRAR_SH_REVIEW,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .REGISTRAR_SH_REVIEW_II,
                    Constants.COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW,
                    Constants.COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW_II,
                  ].includes(row.original.status);
                }

                if (
                  legalDepartmentEmployees.some(
                    (emp) => emp.user._id === currentUser._id
                  )
                ) {
                  return [
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW,
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.LEGAL_REVIEW_II,
                  ].includes(row.original.status);
                }

                return false;
              }) &&
              !onlyShowViewForStrikeOffTransaction &&
              !companyOnStrikeOff && (
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to={
                        row.original?.registrationName &&
                          !row.original?.transferYourBusinessInitiator
                          ? `/companies/${row.original._id}/review`
                          : row.original?.transferYourBusinessInitiator
                            ? `/transferYourBusiness/${row.original._id}/review`
                            : `/companies/${companyId}/dashboard/transactions/${row.original._id}/review`
                      }
                    >
                      <button
                        type="button"
                        onClick={() => null}
                        className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                          } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                      >
                        <>
                          <PencilIcon
                            className="w-5 h-5 mr-2"
                            aria-hidden="true"
                          />
                          Review
                        </>
                      </button>
                    </Link>
                  )}
                </Menu.Item>
              )}

            {actionButtons.includes("courtOrder") &&
              dashboardPermissions.some((permission) => {
                if (
                  permission.name ===
                  Roles_Permissions_Constants.DASHBOARD_PERMISSIONS
                    .EDIT_OTHER_DATA
                ) {
                  return [
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .AWAITING_COURT_ORDER,
                  ].includes(row.original.status);
                }
                return false;
              }) && (
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to={
                        row?.original?.transactionType ===
                          Constants.TRANSACTION_TYPES.MANUAL
                          ? `/companies/${companyId}/dashboard/transactions/${row.original._id}/manual-edit?tab=brsForms`
                          : `/companies/${companyId}/dashboard/transactions/${row.original._id}/review`
                      }
                    >
                      <button
                        type="button"
                        onClick={() => null}
                        className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                          } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                      >
                        <>
                          <UploadIcon
                            className="w-5 h-5 mr-2"
                            aria-hidden="true"
                          />
                          Upload Court Order
                        </>
                      </button>
                    </Link>
                  )}
                </Menu.Item>
              )}

            {actionButtons.includes("intendedDissolution") &&
              dashboardPermissions.some((permission) => {
                if (
                  permission.name ===
                  Roles_Permissions_Constants.DASHBOARD_PERMISSIONS
                    .EDIT_OTHER_DATA
                ) {
                  return [
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .INTENDED_DISSOLUTION,
                  ].includes(row.original.status);
                }
                return false;
              }) &&
              !onlyShowViewForStrikeOffTransaction && (
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to={
                        row?.original?.transactionType ===
                          Constants.TRANSACTION_TYPES.MANUAL
                          ? `/companies/${companyId}/dashboard/transactions/${row.original._id}/manual-edit?tab=brsForms`
                          : `/companies/${companyId}/dashboard/transactions/${row.original._id}/review`
                      }
                    >
                      <button
                        type="button"
                        onClick={() => null}
                        className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                          } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                      >
                        <>
                          <UploadIcon
                            className="w-5 h-5 mr-2"
                            aria-hidden="true"
                          />
                          Upload Intended Dissolution
                        </>
                      </button>
                    </Link>
                  )}
                </Menu.Item>
              )}

            {actionButtons.includes("dissolutionNotice") &&
              dashboardPermissions.some((permission) => {
                if (
                  permission.name ===
                  Roles_Permissions_Constants.DASHBOARD_PERMISSIONS
                    .EDIT_OTHER_DATA
                ) {
                  return [
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .DISSOLUTION_NOTICE,
                  ].includes(row.original.status);
                }
                return false;
              }) &&
              !onlyShowViewForStrikeOffTransaction && (
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to={
                        row?.original?.transactionType ===
                          Constants.TRANSACTION_TYPES.MANUAL
                          ? `/companies/${companyId}/dashboard/transactions/${row.original._id}/manual-edit?tab=brsForms`
                          : `/companies/${companyId}/dashboard/transactions/${row.original._id}/review`
                      }
                    >
                      <button
                        type="button"
                        onClick={() => null}
                        className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                          } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                      >
                        <>
                          <UploadIcon
                            className="w-5 h-5 mr-2"
                            aria-hidden="true"
                          />
                          Upload Dissolution Notice
                        </>
                      </button>
                    </Link>
                  )}
                </Menu.Item>
              )}

            {actionButtons.includes("pendingRegistrarDecision") &&
              dashboardPermissions.some((permission) => {
                if (
                  permission.name ===
                  Roles_Permissions_Constants.DASHBOARD_PERMISSIONS
                    .EDIT_OTHER_DATA
                ) {
                  return [
                    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
                      .PENDING_REGISTRAR_DECISION,
                  ].includes(row.original.status);
                }
                return false;
              }) &&
              !onlyShowViewForStrikeOffTransaction && (
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to={
                        row?.original?.transactionType ===
                          Constants.TRANSACTION_TYPES.MANUAL
                          ? `/companies/${companyId}/dashboard/transactions/${row.original._id}/manual-edit?tab=brsForms`
                          : `/companies/${companyId}/dashboard/transactions/${row.original._id}/review`
                      }
                    >
                      <button
                        type="button"
                        onClick={() => null}
                        className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                          } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                      >
                        <>
                          <UploadIcon
                            className="w-5 h-5 mr-2"
                            aria-hidden="true"
                          />
                          Upload Registrar Decision
                        </>
                      </button>
                    </Link>
                  )}
                </Menu.Item>
              )}


            {actionButtons.includes("signature") &&
              Object.values(
                Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS
              ).includes(row.original.status) &&
              (row.original?.envelopes?.some((envelope) =>
                envelope?.signatures?.some(
                  (signer) => signer?.signer_email_address === currentUser.email
                )
              ) ||
                dashboardRoles.some(
                  (role) =>
                    role.name ===
                    Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR ||
                    role.name ===
                    Roles_Permissions_Constants.DASHBOARD_ROLES.UPLOADER
                )) &&
              !onlyShowViewForStrikeOffTransaction &&
              !companyOnStrikeOff && (
                <Menu.Item>
                  {({ active }) => {
                    let signatureLink = null;
                    let eSignatureLink = null;
                    /**
                     * This code handles e-signature cases
                     */
                    if (row?.original?.eSignatureEmailLinks?.length > 0) {
                      /** Check if the logged in user has an e-signature link */
                      eSignatureLink = getEsignatureEmailLink(
                        currentUser,
                        row.original?.eSignatureEmailLinks
                      );
                    }
                    if (eSignatureLink) {
                      eSignatureLink =
                        "/esign" + eSignatureLink.split("esign")[1];
                      signatureLink = eSignatureLink;
                    } else {
                      /** This is for the manual signing by uploader */
                      signatureLink = `/companies/${companyId}/dashboard/transactions/${row.original._id
                        }/${row.original.status ===
                          Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS
                            .DIRECTOR_SIGNATURE ||
                          row.original.status ===
                          Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS
                            .SHAREHOLDER_SIGNATURE
                          ? "approvals-signature"
                          : row.original.status ===
                            Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS
                              .BRS_FORM_SIGNATURE ||
                            row.original.status ===
                            Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS
                              .BRS_FORM_SIGNATURE_II
                            ? "brs-forms-signature"
                            : `changes-signature?${row?.original?.changeType === "APPOINTMENT"
                              ? "appointment=true"
                              : row?.original?.changeType === "CESSATION"
                                ? "cessation=true"
                                : row?.original?.changeType ===
                                  "CHANGE-OF-PARTICULARS"
                                  ? "changeOfParticulars=true"
                                  : ""
                            }`
                        }`;
                    }
                    return (
                      <Link to={signatureLink}>
                        <button
                          type="button"
                          onClick={() => null}
                          className={`${active
                              ? "bg-violet-500 text-white"
                              : "text-gray-900"
                            } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                        >
                          <>
                            <PencilIcon
                              className="w-5 h-5 mr-2"
                              aria-hidden="true"
                            />
                            Signature
                          </>
                        </button>
                      </Link>
                    );
                  }}
                </Menu.Item>
              )}
            {actionButtons.includes("edit") &&
              (dashboardRoles.some(
                (role) =>
                  role.name ===
                  Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR ||
                  role.name ===
                  Roles_Permissions_Constants.DASHBOARD_ROLES.UPLOADER
              ) ||
                row.original.createdBy === currentUser._id) &&
              !onlyShowViewForStrikeOffTransaction &&
              !companyOnStrikeOff && (
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to={
                        row?.original?.transactionType ===
                          Constants.TRANSACTION_TYPES.MANUAL
                          ? `/companies/${companyId}/dashboard/transactions/${row.original._id}/manual-edit`
                          : row?.original?.transferYourBusinessInitiator
                            ? `/companies/${row.original._id}/dashboard?transferYourBusiness`
                            : `/companies/${companyId}/dashboard/transactions/${row.original._id}/recent-changes`
                      }
                    >
                      <button
                        type="button"
                        onClick={() => null}
                        className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                          } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                      >
                        <PencilAltIcon
                          className="w-5 h-5 mr-2"
                          aria-hidden="true"
                        />
                        <span className="text-red-500 font-medium"> Edit </span>
                      </button>
                    </Link>
                  )}
                </Menu.Item>
              )}
            {actionButtons.includes("delete") &&
              (dashboardRoles.some(
                (role) =>
                  role.name ===
                  Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR ||
                  role.name ===
                  Roles_Permissions_Constants.DASHBOARD_ROLES.UPLOADER
              ) ||
                row.original.createdBy === currentUser._id) &&
              !onlyShowViewForStrikeOffTransaction &&
              !companyOnStrikeOff && (
                <Menu.Item>
                  {({ active }) => (
                    <button
                      type="button"
                      onClick={() => {
                        setShowConfirmationDialog(true);
                        setSelectedRow(row);
                        setActionType("delete");
                      }}
                      className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                        } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                    >
                      <TrashIcon className="w-5 h-5 mr-2" aria-hidden="true" />
                      <span className="text-red-500 font-medium"> Delete </span>
                    </button>
                  )}
                </Menu.Item>
              )}
            {actionButtons.includes("recall") &&
              dashboardRoles.some(
                (role) =>
                  role.name ===
                  Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
              ) &&
              !onlyShowViewForStrikeOffTransaction &&
              !companyOnStrikeOff && (
                <Menu.Item>
                  {({ active }) => (
                    <button
                      type="button"
                      onClick={() => {
                        setActionType("recall");
                        setSelectedRow(row);
                        setShowRecallModal(true);
                      }}
                      hidden={row.status === "DRAFT"}
                      disabled={row.isReviewed}
                      className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                        } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                    >
                      <RefreshIcon
                        className="w-5 h-5 mr-2"
                        aria-hidden="true"
                      />
                      <span className="text-red-500 font-medium"> Recall </span>
                    </button>
                  )}
                </Menu.Item>
              )}
            {isCorrectionActionNeeded && (
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedRow(row);
                      setActionType("corrections");
                      setBatchNo(row.original.batchNo || row.original.trxRef);
                      row.toggleRowExpanded();
                      setShowCorrectionModal(true);
                    }}
                    className={`${active ? "bg-violet-500 text-white" : "text-gray-900"
                      } group flex rounded-md items-center w-full px-2 py-2 text-sm disabled:cursor-not-allowed disabled:text-gray-400`}
                  >
                    <PencilAltIcon
                      className="w-5 h-5 mr-2"
                      aria-hidden="true"
                    />
                    <span className="text-red-500 font-medium">
                      Corrections
                    </span>
                  </button>
                )}
              </Menu.Item>
            )}
          </>
        }
      </TableActionMenuWrapper>
    </div>
  );
};

const ConfirmationModal = ({
  selectedRow,
  setShowConfirmationDialog,
  setUpdateTable,
  currentPage,
  companyId,
}) => {
  const [modelText, setModelText] = useState({
    heading: "Your details will be deleted",
    text: "Are you sure you want to delete the transaction?",
  });

  const dispatch = useDispatch();
  const { toast } = useToast(5000);

  const handleClose = () => {
    setShowConfirmationDialog(false);
  };

  const [submitting, setSubmitting] = useState(false);

  const deleteSelectedTransaction = async () => {
    setSubmitting(true);
    const { officials, beneficialOwners } = selectedRow.original;
    if (
      selectedRow.original?.changeType ===
      Constants.TRANSACTION_CHANGE_TYPES.APPOINTMENT
    ) {
      if (officials?.length > 0) {
        officials.forEach(async (official) => {
          if (official?.tempDesignation) {
            await dispatch(
              updateCompanyOfficialAsync({
                officialId: official._id,
                data: {
                  tempDesignation: "",
                },
              })
            );
          } else {
            await dispatch(
              deleteCompanyOfficialAsync({
                officialId: official._id,
                idType: official.idType,
                companyId,
              })
            );
          }
        });
      }
    }
    if (
      selectedRow.original?.changeType ===
      Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_PARTICULARS
    ) {
      if (officials?.length > 0) {
        officials.forEach(async (official) => {
          if (official?._id) {
            await dispatch(
              updateCompanyOfficialAsync({
                officialId: official._id,
                data: {
                  companyId,
                  idType: official.idType,
                  changedFields: {},
                },
              })
            );
          }
        });
      }

      if (beneficialOwners && beneficialOwners?.length > 0) {
        beneficialOwners.forEach(async (bo) => {
          if (bo?._id) {
            await dispatch(
              editBeneficialOwnerAsync({
                companyId,
                beneficialOwnerId: bo?._id,
                data: {
                  changedFields: {},
                },
              })
            );
          }
        });
      }
    }
    if (selectedRow?.original?.transferYourBusinessInitiator) {
      // Delete transfered company
      await dispatch(
        deleteCompany({
          companyId: selectedRow.original._id,
          queryParams: {
            isForTransfer: true,
          },
        })
      );
    } else {
      await dispatch(
        deleteInitiatedTransactionChangeAsync({
          companyId,
          initiateId: selectedRow.original._id,
        })
      );
    }

    await dispatch(getCompanyDashboardAsync({ companyId }));
    dispatch(resetTransactionChange());
    setUpdateTable(true);
    setShowConfirmationDialog(false);
    setSubmitting(false);
    toast("success", "Application has been deleted successfully");
  };

  return (
    <Dialog open={true} onClose={handleClose}>
      <h2 className="text-xl font-medium text-red-500">{modelText.heading}</h2>
      <div className="py-5 whitespace-normal">
        <span className="font-normal">{modelText.text}</span>
      </div>
      <div className="flex justify-end">
        <div className="p-1">
          <Button
            className={`inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-transparent rounded-md shadow-sm hover:bg-optional hover:text-sflPrimary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed`}
            onClick={() => setShowConfirmationDialog(false)}
            disabled={submitting}
          >
            Cancel
          </Button>
        </div>
        <div className="p-1">
          <Button
            className={`inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-red-500 hover:bg-optional hover:text-sflPrimary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 disabled:cursor-not-allowed`}
            onClick={() => {
              deleteSelectedTransaction();
            }}
            disabled={submitting}
          >
            {submitting ? (
              <div className="flex">
                <SpinnerIcon />
                Deleting...
              </div>
            ) : (
              "I Confirm"
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

const RecallModal = ({
  selectedRow,
  setUpdateTable,
  setShowRecallModal,
  onComplete,
}) => {
  const [modelText, setModelText] = useState({
    heading: "Your application stage will be revert back",
    text: "Are you sure you want to continue the transaction to recall?",
  });

  const dispatch = useDispatch();
  const { toast } = useToast(5000);

  const handleClose = () => {
    setShowRecallModal(false);
  };

  const [submitting, setSubmitting] = useState(false);

  const recallTransaction = async () => {
    setSubmitting(true);

    if (selectedRow?.original?.transferYourBusinessInitiator) {
      // Recall for company
      await dispatch(
        handleRecallApplication({
          companyId: selectedRow?.original?._id,
        })
      );
    } else {
      // Recall for InitiateTransaction
      const { officialId, companyId, status, _id } = selectedRow.original;

      const result = await dispatch(
        recallInitiatedTransactionChangeAsync({
          companyId,
          data: {
            trxId: _id,
            status,
          },
        })
      );
    }

    setUpdateTable(true);
    setShowRecallModal(false);
    setSubmitting(false);
    toast("success", "Application has been recalled successfully");
    onComplete("Recall is done successfully");
  };

  return (
    <Dialog open={true} onClose={handleClose}>
      <h2 className="text-xl font-medium text-red-500">{modelText.heading}</h2>
      <div className="py-5 whitespace-normal">
        <span className="font-normal">{modelText.text}</span>
      </div>
      <div className="flex justify-end">
        <div className="p-1">
          <Button
            className={`inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gray-500 border border-transparent rounded-md shadow-sm hover:bg-optional hover:text-sflPrimary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed`}
            onClick={() => setShowRecallModal(false)}
            disabled={submitting}
          >
            Cancel
          </Button>
        </div>
        <div className="p-1">
          <Button
            className={`inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-sflPrimary hover:bg-optional hover:text-sflPrimary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed`}
            onClick={() => {
              recallTransaction();
            }}
            disabled={submitting}
          >
            {submitting ? (
              <div className="flex">
                <SpinnerIcon />
                Recalling...
              </div>
            ) : (
              "I Confirm"
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default TransactionsList;
